import { SuspensePageBoundary } from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { MorphemeInfoPanelLoadingView } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content";
import { GraphemeInfoDictionaryScreenSuspense } from "#grapheme-info-dictionary-screen-suspense";

export function GraphemeInfoDictionaryScreen({ grapheme }: { grapheme: string }) {
  return (
    <SuspensePageBoundary
      // While the info slice loads in a defensive cold-query path, show
      // the "Overview" header with a spinner in place of the chevron instead of a blank page.
      fallback={<MorphemeInfoPanelLoadingView />}
      location={import.meta.location}
    >
      <GraphemeInfoDictionaryScreenSuspense character={grapheme} />
    </SuspensePageBoundary>
  );
}
